import { Checkbox } from '@mui/material';

function UncheckedIcon() {
  return <span className="block h-5 w-5 rounded border border-ash-900" />;
}

function CheckedIcon() {
  return (
    <span className="flex h-5 w-5 items-center justify-center rounded border border-ash-900 bg-ash-900">
      <svg viewBox="0 0 20 20" className="h-[18px] w-[18px]" aria-hidden="true">
        <path d="M15.938 6.25l-7.5 7.5L4.688 10" fill="none" stroke="white" strokeWidth="1.5" />
      </svg>
    </span>
  );
}

function IndeterminateIcon() {
  return (
    <span className="flex h-5 w-5 items-center justify-center rounded border border-ash-900 bg-ash-900">
      <svg viewBox="0 0 20 20" className="h-[18px] w-[18px]" aria-hidden="true">
        <path d="M5 10h10" fill="none" stroke="white" strokeWidth="2" />
      </svg>
    </span>
  );
}

export function SelectCheckbox({ checked, indeterminate = false }: { checked: boolean; indeterminate?: boolean }) {
  return (
    <Checkbox
      checked={checked}
      indeterminate={indeterminate}
      icon={<UncheckedIcon />}
      checkedIcon={<CheckedIcon />}
      indeterminateIcon={<IndeterminateIcon />}
      inputProps={{ tabIndex: -1, 'aria-hidden': true }}
      sx={{ width: 20, height: 20, padding: 0, margin: '2px 0' }}
    />
  );
}
